// FETCH ALL PROCESS_ADD_ON
export const FETCH_PROCESS_ADD_ON_REQUEST_DK = 'FETCH_PROCESS_ADD_ON_REQUEST_DK';
export const FETCH_PROCESS_ADD_ON_SUCCESS_DK = 'FETCH_PROCESS_ADD_ON_SUCCESS_DK';
export const FETCH_PROCESS_ADD_ON_FAILURE_DK = 'FETCH_PROCESS_ADD_ON_FAILURE_DK';

// CREATE PROCESS_ADD_ON
export const CREATE_PROCESS_ADD_ON_REQUEST_DK = 'CREATE_PROCESS_ADD_ON_REQUEST_DK';
export const CREATE_PROCESS_ADD_ON_SUCCESS_DK = 'CREATE_PROCESS_ADD_ON_SUCCESS_DK';
export const CREATE_PROCESS_ADD_ON_FAILURE_DK = 'CREATE_PROCESS_ADD_ON_FAILURE_DK';

// UPDATE PROCESS_ADD_ON
export const UPDATE_PROCESS_ADD_ON_REQUEST_DK = 'UPDATE_PROCESS_ADD_ON_REQUEST_DK';
export const UPDATE_PROCESS_ADD_ON_SUCCESS_DK = 'UPDATE_PROCESS_ADD_ON_SUCCESS_DK';
export const UPDATE_PROCESS_ADD_ON_FAILURE_DK = 'UPDATE_PROCESS_ADD_ON_FAILURE_DK';

// FETCH SINGLE STATE OF PROCESS_ADD_ON
export const FETCH_SINGLE_PROCESS_ADD_ON_REQUEST_DK = 'FETCH_SINGLE_PROCESS_ADD_ON_REQUEST_DK';
export const FETCH_SINGLE_PROCESS_ADD_ON_SUCCESS_DK = 'FETCH_SINGLE_PROCESS_ADD_ON_SUCCESS_DK';
export const FETCH_SINGLE_PROCESS_ADD_ON_FAILURE_DK = 'FETCH_SINGLE_PROCESS_ADD_ON_FAILURE_DK';

// DELETE PROCESS_ADD_ON
export const DELETE_PROCESS_ADD_ON_REQUEST_DK = 'DELETE_PROCESS_ADD_ON_REQUEST_DK';
export const DELETE_PROCESS_ADD_ON_SUCCESS_DK = 'DELETE_PROCESS_ADD_ON_SUCCESS_DK';
export const DELETE_PROCESS_ADD_ON_FAILURE_DK = 'DELETE_PROCESS_ADD_ON_FAILURE_DK';

export const RESET_PROCESS_ADD_ON_INFO_DK = 'RESET_PROCESS_ADD_ON_INFO_DK';

export const CREATE_PROCESS_ADD_ON_FORM_DK = 'CREATE_PROCESS_ADD_ON_FORM_DK';

export const UPDATE_PROCESS_ADD_ON_FORM_DK = 'UPDATE_PROCESS_ADD_ON_FORM_DK';
